import React, { useEffect, useState, useCallback } from 'react';
import { Users, Link2, Copy, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' });
const lienPublic = (t) => `${window.location.origin}/auto-evaluation/${t}`;

const LigneSalarie = ({ s, entretien, onLancer }) => (
  <div data-testid={`entretien-salarie-${s.id}`} className="bg-white border border-stone-200 rounded-xl p-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div><p className="font-semibold text-stone-800">{s.prenom} {s.nom}</p><p className="text-xs text-stone-500">{s.poste || '—'}</p></div>
      {entretien ? (
        <div className="flex items-center gap-2">
          <span className={`text-xs px-2 py-0.5 rounded-full ${entretien.statut === 'rempli' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
            {entretien.statut === 'rempli' ? 'Auto-évaluation remplie' : 'En attente du salarié'}</span>
          {entretien.statut === 'envoye' && (
            <Button data-testid={`entretien-copier-${s.id}`} size="sm" variant="outline" className="rounded-full"
              onClick={() => { navigator.clipboard.writeText(lienPublic(entretien.token)); toast.success('Lien copié, envoie-le au salarié.'); }}>
              <Copy className="w-3.5 h-3.5 mr-1" />Copier le lien</Button>
          )}
        </div>
      ) : (
        <Button data-testid={`entretien-lancer-${s.id}`} size="sm" className="rounded-full bg-emerald-700 hover:bg-emerald-800" onClick={() => onLancer(s.id)}>
          <Link2 className="w-3.5 h-3.5 mr-1" />Lancer l'auto-évaluation</Button>
      )}
    </div>
    {entretien?.synthese && <p data-testid={`entretien-synthese-${s.id}`} className="text-sm text-stone-700 mt-3 whitespace-pre-line border-t border-stone-100 pt-3">
      <span className="font-semibold text-emerald-800">Synthèse de Caroline Petit : </span>{entretien.synthese}</p>}
  </div>
);

export default function EntretiensRHPage() {
  const [data, setData] = useState(null);
  const charger = useCallback(async () => {
    const r = await fetch(`${API}/api/rh/entretiens`, { headers: headers() });
    if (r.ok) setData(await r.json());
  }, []);
  useEffect(() => { charger(); }, [charger]);

  const lancer = async (id) => {
    const r = await fetch(`${API}/api/rh/entretiens`, { method: 'POST', headers: headers(), body: JSON.stringify({ salarie_id: id }) });
    if (r.ok) { const d = await r.json(); navigator.clipboard?.writeText(lienPublic(d.token)); toast.success('Auto-évaluation créée, lien copié.'); charger(); }
  };

  return (
    <div data-testid="entretiens-rh-page" className="p-6 lg:p-10 max-w-4xl">
      <h1 className="text-3xl font-bold text-stone-900 flex items-center gap-3"><Users className="w-8 h-8 text-emerald-700" />Entretiens & auto-évaluations</h1>
      <p className="text-sm text-stone-500 mt-2 mb-8">Chaque salarié remplit son auto-évaluation depuis un lien. Caroline Petit (RH) t'en fait la synthèse pour préparer l'entretien.</p>
      {!data ? <Loader2 className="w-6 h-6 animate-spin text-stone-400" /> : (
        <div className="space-y-3">
          {data.salaries.map((s) => <LigneSalarie key={s.id} s={s} entretien={data.entretiens.find((e) => e.salarie_id === s.id)} onLancer={lancer} />)}
          {data.salaries.length === 0 && <p className="text-stone-500">Aucun salarié enregistré.</p>}
        </div>
      )}
    </div>
  );
}
